import { getFormattedDatetime } from '../../Util/Util';
import * as actionTypes from './app-repo-types';

const INITIAL_STATE = {
    data: []
}

const appRepoReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
       case actionTypes.APP_REPO_LIST:
            return {
                data: [
                    ...action.payload.data
                ]
            };
        default: 
            return state;
    }
};

export default appRepoReducer;